// src/modules/app-views/crm/constants/formFieldTypes.js
// *******************************************************************************
// FIELD TYPE REGISTRY
// *******************************************************************************
// Maps field type keys to metadata for the dynamic form builder.
// Adding a new type = 1 entry here + 1 case in the FormTab renderer.
// *******************************************************************************

import {
  FontSizeOutlined,
  AlignLeftOutlined,
  NumberOutlined,
  DollarOutlined,
  DownSquareOutlined,
  AppstoreOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
  SwapOutlined,
  PhoneOutlined,
  MailOutlined,
  LinkOutlined,
} from '@ant-design/icons';
import translateX from 'utils/translateX';

const FIELD_TYPE_REGISTRY = {
  text:        { label: 'text',        icon: FontSizeOutlined,    color: 'blue',      hasOptions: false },
  // textarea:    { label: 'textarea',    icon: AlignLeftOutlined,   color: 'cyan',      hasOptions: false },
  // number:      { label: 'number',      icon: NumberOutlined,      color: 'green',     hasOptions: false },
  // currency:    { label: 'currency',    icon: DollarOutlined,      color: 'gold',      hasOptions: false },
  select:      { label: 'select',      icon: DownSquareOutlined,  color: 'purple',    hasOptions: true },
  // multiselect: { label: 'multiselect', icon: AppstoreOutlined,    color: 'magenta',   hasOptions: true },
  // radio:       { label: 'radio',       icon: CheckCircleOutlined, color: 'volcano',   hasOptions: true },
  // date:        { label: 'date',        icon: CalendarOutlined,    color: 'geekblue',  hasOptions: false },
  // switch:      { label: 'switch',      icon: SwapOutlined,        color: 'lime',      hasOptions: false },
  // phone:       { label: 'phone',       icon: PhoneOutlined,       color: 'orange',    hasOptions: false },
  // email:       { label: 'email',       icon: MailOutlined,        color: 'red',       hasOptions: false },
  // url:         { label: 'url',         icon: LinkOutlined,        color: 'cyan',      hasOptions: false },
};

// Returns options array for a Select component
function getFieldTypeOptions() {
  return Object.entries(FIELD_TYPE_REGISTRY).map(([key, meta]) => ({
    value: key,
    label: translateX(meta.label),
  }));
}

// Returns metadata for a given field type key
function getFieldTypeMeta(type) {
  return FIELD_TYPE_REGISTRY[type] || FIELD_TYPE_REGISTRY.text;
}

export { FIELD_TYPE_REGISTRY, getFieldTypeOptions, getFieldTypeMeta };
export default FIELD_TYPE_REGISTRY;
